import DeleteThinIcon from "components/Icons/DeleteThinIcon";
import EditDropIcon from "components/Icons/EditDropIcon";
import { TableCardStyle } from "components/TableCard/TableCard.style";
import { CoverPageType } from "redux/slice/coverPageSlice";
import { Spin } from "antd";
import { Button } from "components/ui-component";

interface CoverPageCardDataProps {
  coverPageCardData: CoverPageType[];
  isLoading: boolean;
  editCoverPage: (coverPage: CoverPageType) => void;
  deleteCoverPage: (coverPageId: string) => void;
  openAssignedUsersModal: (row: CoverPageType) => void;
  openAssignedNumbersModal: (row: CoverPageType) => void;
}

const CoverPageTableCard = ({
  coverPageCardData,
  isLoading,
  editCoverPage,
  deleteCoverPage,
  openAssignedNumbersModal,
  openAssignedUsersModal,
}: CoverPageCardDataProps) => {
  return (
    <>
      {isLoading ? (
        <Spin className="loading-spinner" />
      ) : (
        coverPageCardData?.length > 0 &&
        coverPageCardData?.map((coverPage) => (
          <TableCardStyle key={coverPage?.id}>
            <div className="d-flex font-14 justify-content-between align-item-center">
              <div className="to-number capitalize">{`${coverPage?.name}`}</div>
            </div>
            <div className="d-flex font-14 justify-content-between align-item-center">
              <div className="date">{coverPage?.description}</div>
            </div>
            <div className="d-flex font-14 justify-content-between align-item-center">
              <Button
                type="text"
                onClick={() => {
                  openAssignedUsersModal(coverPage);
                }}
                className="black-btntext font-14"
              >
                Assigned Users:{" "}
                <span style={{ textDecoration: "underline" }}>
                  {coverPage?.assigned_users?.length || 0}
                </span>
              </Button>
              <Button
                type="text"
                onClick={() => {
                  openAssignedNumbersModal(coverPage);
                }}
                className="black-btntext font-14"
              >
                Assigned Numbers:{" "}
                <span style={{ textDecoration: "underline" }}>
                  {coverPage?.assigned_numbers?.length || 0}
                </span>
              </Button>
            </div>
            <div className="d-flex font-14 justify-content-between align-item-center">
              <Button
                type="text"
                className="d-flex gap-2 font-14 priamry-btntext"
                onClick={() => {
                  editCoverPage(coverPage);
                }}
              >
                <EditDropIcon />
                Edit
              </Button>

              <Button
                type="text"
                className="d-flex gap-2 delete font-14 "
                onClick={() => {
                  deleteCoverPage(coverPage?.id);
                }}
              >
                <DeleteThinIcon width="14" height="14" strokeWidth="2" />
                Delete
              </Button>
            </div>
          </TableCardStyle>
        ))
      )}
    </>
  );
};

export default CoverPageTableCard;
